import api from "./api";

const OurServiceAPI = {
    getAll: () => api.get("/our-services/all"),
    getById: (id) => api.get(`/our-services/details/${id}`),
    update: (params) => api.post(`/our-services/update`, params)
};

export default OurServiceAPI;